import {BaseApi} from './base-api';
import Vue from 'vue';

export class MiscApi extends BaseApi {
  static apiUri = 'misc';
  static apiUriObject = 'misc/object';
  static apiUriBooking = 'misc/booking';

  /** @return {Promise<EntityHttpResponse<PageResponse<MiscObjectDto[]>>>} */
  static getAllObjectMiscs () {
    return Vue.http.get(this.apiUriObject)
  }

  /**
   * @return {Promise<EntityHttpResponse<MiscObjectDto>>}
   * @param {MiscObjectCreateRequest} miscCreateRequest
   * */
  static createObjectMisc (miscCreateRequest) {
    return Vue.http.post(this.apiUriObject, miscCreateRequest)
  }

  /**
   * @return {Promise<EntityHttpResponse<MiscObjectDto>>}
   * @param {Number} miscId
   * @param {MiscObjectUpdateRequest} miscUpdateRequest
   * */
  static updateObjectMisc (miscId, miscUpdateRequest) {
    return Vue.http.patch(this.apiUriObject + '/' + miscId, miscUpdateRequest)
  }

  /**
   * @return {Promise<EntityHttpResponse<void>>}
   * @param {Number} miscId
   * */
  static deleteObjectMisc (miscId) {
    return Vue.http.delete(this.apiUriObject + '/' + miscId)
  }


  /** @return {Promise<EntityHttpResponse<MiscBookingDto[]>>} */
  static getAllBookingMiscs () {
    return Vue.http.get(this.apiUriBooking);
  }

  /** @return {Promise<EntityHttpResponse<MiscBookingDto>>}
   * @param {MiscBookingCreateRequest} newBookingMisc
   * */
  static createBookingMisc (newBookingMisc) {
    return Vue.http.post(this.apiUriBooking, newBookingMisc);
  }

  /** @return {Promise<EntityHttpResponse<MiscBookingDto>>}
   * @param {Number} miscId
   * @param {MiscBookingUpdateRequest} updatedBookingMisc
   * */
  static updateBookingMisc ( miscId, updatedBookingMisc) {
    return Vue.http.patch(this.apiUriBooking + '/' + miscId, updatedBookingMisc);
  }

  /** @return {Promise<EntityHttpResponse<void>>}
   * @param {Number} miscId
   * */
  static deleteBookingMisc (miscId) {
    return Vue.http.delete(this.apiUriBooking + '/' + miscId);
  }
}
